<template>
  <div ref="ShareholderDirectorInformationAnchor">
    <!-- 编辑模式：添加按钮 + 列表 -->
    <template v-if="!isReadonly">
      <div class="pb36">
        <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="addHandle" class="fs12">{{ $t("enroll.intitle.addButton") }}</el-button>
        <info-popover placement="bottom" icon="el-icon-warning">
          <div class="linkWrap">
            <p class="fs12" v-if="isMalaysia">{{ $t("enroll.intitle.malaysia.caution") }}</p>
            <p class="fs12" v-else>{{ $t("enroll.intitle.caution") }}</p>
            <p class="pt2">
              <span class="fs12">{{ $t("common.reference") }}</span>
              <a
                href="https://www.acra.gov.sg/how-to-guides/setting-up-a-local-company/appointing-directors-company-secretary-and-other-key-personnel"
                target="_blank"
                class="lh14"
              >
                https://www.acra.gov.sg/how-to-guides/setting-up-a-local-company/appointing-directors-company-secretary-and-other-key-personnel
              </a>
            </p>
          </div>
        </info-popover>
      </div>
      <div v-if="innerList.length !== 0">
        <el-table :data="innerList | filtration" border class="wdb100">
          <el-table-column prop="position" :label="$t('enroll.intitle.type')" align="center" min-width="100px">
            <template slot-scope="scope">
              <p>{{ getGlobalLabel("positionHeldTypeList", scope.row.positionHeld) }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="fullName" :label="$t('enroll.intitle.compellation')" align="center"></el-table-column>
          <el-table-column :label="$t('enroll.intitle.aggregate')" align="center" :formatter="summation"></el-table-column>
          <el-table-column :label="$t('common.operation')" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" class="mr6" @click="editHandle(scope.$index, scope.row)">{{ $t("common.button.edit") }}</el-button>
              <el-button type="text" icon="el-icon-delete" class="red" @click="deleteHandle(scope.$index, scope.row)">{{ $t("common.button.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <p class="pt10 fs12 lh16 crgy919">
        {{ $t("enroll.intitle.suggest") }}
      </p>
    </template>

    <!-- 回显模式：直接平铺展示股东/董事详情 -->
    <template v-else>
      <div v-for="(row, index) in normalizedList" :key="`shareholderView-${index}`" class="viewCard">
        <p class="blueDark viewCardTitle">{{ getGlobalLabel("memberTypeList", row.memberType) }}</p>
        <div class="pt10 wdb100">
          <company-form-panel v-if="row.memberType === 'CORPORATE'" :form="row" :isReadonly="true" :isMalaysia="isMalaysia"></company-form-panel>
          <personal-form-panel v-else :form="row" :isReadonly="true" :isMalaysia="isMalaysia"></personal-form-panel>
        </div>
      </div>
      <p class="pt10 fs12 lh16 crgy919">
        {{ $t("enroll.intitle.suggest") }}
      </p>
    </template>

    <!-- 新建/编辑 - 弹窗(编辑模式专用) -->
    <add-or-update v-if="!isReadonly" :isMalaysia="isMalaysia" ref="addOrUpdateRef" @update="updateItem"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate.vue";
import CompanyFormPanel from "./modal/CompanyFormPanel.vue";
import PersonalFormPanel from "./modal/PersonalFormPanel.vue";
import { normalizeCompanyForm, normalizePersonalForm } from "./modal/formFactory";
import { addition } from "@/utils/count";
import { scrollToRef } from "@/utils/common";
import { mapState, mapGetters } from "vuex";

export default {
  name: "ShareholderDirectorInformation",
  components: { AddOrUpdate, CompanyFormPanel, PersonalFormPanel },
  filters: {
    // 过滤名义董事
    filtration(arr) {
      const newArr = arr.filter(item => item.positionHeld != "NOMINEE_DIRECTOR");
      return newArr;
    },
  },
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    /** v-model 绑定值：股东/董事信息数组 */
    value: { type: Array, default: () => [] },
    /** 是否马来西亚（用于显示马来专属的注册地址/服务地址模块） */
    isMalaysia: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasNomineeDirector"]),
    ...mapGetters("constant", ["getGlobalLabel"]),
    /** 内部列表，与 value 保持同步 */
    innerList() {
      return this.value || [];
    },
    /** 回显模式：归一化后的股东/董事列表(过滤名义董事 + 补全缺失字段，避免模板访问 undefined 报错) */
    normalizedList() {
      return (this.innerList || [])
        .filter(item => item.positionHeld != "NOMINEE_DIRECTOR")
        .map(row => (row.memberType === "CORPORATE" ? normalizeCompanyForm(row) : normalizePersonalForm(row)));
    },
  },
  methods: {
    // 所占股份数量 - 求和
    summation(row) {
      const sharesInfo = row.sharesInfo;
      if (!sharesInfo || sharesInfo.length === 0) {
        return null;
      } else {
        let sum = 0;
        for (let i in sharesInfo) {
          sum = addition(sum, sharesInfo[i].quantityOfSharesAllotted);
        }
        return sum;
      }
    },
    /** 同步变更到父组件 */
    emitInput(newList) {
      this.$emit("input", newList);
    },
    // 新建
    addHandle() {
      this.$refs.addOrUpdateRef.init("add");
    },
    // 编辑
    editHandle(index, row) {
      this.$refs.addOrUpdateRef.init(index, row);
    },
    // 删除
    deleteHandle(index) {
      const list = [...this.innerList];
      list.splice(index, 1);
      this.emitInput(list);
    },
    // 更新（新增或编辑回调）
    updateItem(obj, index) {
      let list = JSON.parse(JSON.stringify(this.innerList));
      if (index === "add") {
        list.push(obj);
      } else {
        list.splice(index, 1, obj);
      }
      this.emitInput(list);
    },
    // 校验（由父组件触发）
    validate() {
      // 必须填写至少有1个股东 和 1个董事
      let shareholderHas = false;
      let directorHas = false;
      this.innerList.forEach(item => {
        if (item.positionHeld == "SHAREHOLDER") {
          shareholderHas = true;
        }
        if (item.positionHeld == "DIRECTOR") {
          directorHas = true;
        }
        if (item.positionHeld == "DIRECTOR_AND_SHAREHOLDER") {
          shareholderHas = true;
          directorHas = true;
        }
      });
      if (this.applymentHasNomineeDirector) {
        // 所选服务含有名义董事
        if (!shareholderHas) {
          // 至少填写1个股东
          this.$message.warning(this.$t("common.warning.minimum01"));
          scrollToRef("ShareholderDirectorInformationAnchor", this);
          return false;
        }
      } else {
        // 所选服务不包含名义董事
        if (!shareholderHas || !directorHas) {
          // 至少填写1个股东和1个董事
          this.$message.warning(this.$t("common.warning.minimum02"));
          scrollToRef("ShareholderDirectorInformationAnchor", this);
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 回显模式 - 股东/董事详情卡片 */
.viewCard {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 0 20px 10px;
  margin-bottom: 20px;

  .viewCardTitle {
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 1px solid #e4e7ed;
  }
}
</style>
